var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageStatus === 'infoDetail')?_c('InfoDetail',{on:{"changeToCertVerify":function($event){return _vm.changeToCertVerify()}}}):_vm._e(),(_vm.pageStatus === 'certVerify')?_c('CertVerify',{on:{"changeToInfoDetail":function($event){return _vm.changeToInfoDetail()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }